// extracted by mini-css-extract-plugin
export var button = "_1v-1";
export var featuredLink = "_1v-4";
export var spinner = "_1v-2";
export var spinnerContainer = "_1v-3";
export var text = "_1v-0";